import { useRef, useState } from 'react'

import { getItemsIds } from '../../../../utils/common'
import {
  DocFlowSelectModal,
  getDocFlowSelectModalConnectedItems,
} from '../../../DocFlowSelectModal'
import { TableModalConnectionActions } from '../../../TableModal'
import { useRequestConnectDocFlowsModalOpener } from '../useRequestConnectDocFlowsModalOpener'
import { useRequestDisconnectDocFlows } from '../useRequestDisconnectDocFlows'

export function useRequestTableDocFlows({
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const [tagActionModal, setTagActionModal] = useState(null)
  const tagModalRef = useRef(null)

  function handleReloadAfterConnect() {
    tagModalRef.current?.refresh?.()

    onReload()
  }

  const { handleOpenConnectDocFlows } = useRequestConnectDocFlowsModalOpener({
    onCloseModal,
    onReload: handleReloadAfterConnect,
    onSetModal,
  })

  const { handleOpenDisconnectDocFlows } = useRequestDisconnectDocFlows({
    onCloseModal,
    onSetModal,
  })

  function handleCloseTagModal() {
    setTagActionModal(null)
  }

  function handleDisconnectStart() {
    tagModalRef.current?.setLoading?.(true)
  }

  function handleDisconnectSuccess() {
    onReload()

    tagModalRef.current?.unselectAll?.()
    tagModalRef.current?.refresh?.()
  }

  function handleDisconnectSettled() {
    tagModalRef.current?.setLoading?.(false)
  }

  function handleClickDisconnect(requestId) {
    handleOpenDisconnectDocFlows({
      docFlowIds: getItemsIds(tagModalRef.current?.selected),
      requestId,
      onSettled: handleDisconnectSettled,
      onStart: handleDisconnectStart,
      onSuccess: handleDisconnectSuccess,
    })
  }

  function handleClickDocFlowTag({ itemId }) {
    const buttonConnectProps = {
      onClick: () => handleOpenConnectDocFlows(itemId),
    }

    const buttonDisconnectProps = {
      onClick: () => handleClickDisconnect(itemId),
    }

    setTagActionModal(
      <DocFlowSelectModal
        Actions={TableModalConnectionActions}
        actionsProps={{
          ButtonCancel: null,
          ButtonDisconnectAll: null,
          buttonAttachProps: {
            text: 'Modal.ConfirmBtnKey',
          },
          buttonConnectProps,
          buttonDisconnectProps,
          emptySelectionTooltipKey:
            'Modal.DocFlowsDisconnectEmptySelectionTooltipKey',
        }}
        counterProps={{
          text: 'Modal.ConnectedDocFlowsCountBtnKey',
        }}
        entityId={itemId}
        headerProps={{
          text: 'Modal.ConnectedDocFlowsTitleKey',
        }}
        loadItems={getDocFlowSelectModalConnectedItems}
        ref={tagModalRef}
        onClose={handleCloseTagModal}
      />
    )
  }

  return {
    docFlowTagModal: tagActionModal,
    handleClickDocFlowTag,
  }
}
